export const Process = {
  Order: 'Order',
  BulkOrder: 'BulkOrder',
  BasketOrder: 'BasketOrder',
  Deposit: 'Deposit',
  Withdraw: 'Withdraw',
  Transfer: 'Transfer',
  CorpEvent: 'CorpEvent'
}

export const CustomHandlers = [
  'Offer'
]